import React, { useEffect, useState } from 'react';
import { FlatList, Platform, StyleSheet, } from 'react-native';
import { withTheme, SearchBar, ListItem as BaseListItem, Text, } from '@rneui/themed';
import { useDebounce } from 'use-debounce';
import { useSearchQuery } from '@annunciate/query';
import { ListItem } from '../list';
import { useTheme, SearchRecommendations, useReactiveThemeProperty, } from '../..';
import { SearchListEmptyComponent } from './SearchListEmptyComponent';
export const UnthemedSearch = ({ shouldThrow = false, onQueryUpdated, initialQuery = '', EmptySearchComponent, listItemContainerStyle, }) => {
    const horizontalGutter = useReactiveThemeProperty('horizontalGutter');
    const [display, setDisplay] = useState(initialQuery);
    const [query] = useDebounce(display, 1000);
    const { colors: { backgroundPrimary, borderSecondary, textPrimary, } } = useTheme();
    useEffect(() => {
        if (onQueryUpdated)
            onQueryUpdated(query);
    }, [query]);
    const { isFetchingNextPage, isFetchingPreviousPage, isPending, hasNextPage, data, fetchNextPage, error, } = useSearchQuery(query);
    const isLoadingPage = isFetchingNextPage || isFetchingPreviousPage;
    if (isLoadingPage) {
        data?.results.push([
            { item: false },
        ]);
    }
    if (error && shouldThrow) {
        throw error;
    }
    const renderItem = ({ item: { item } }) => (React.createElement(ListItem, { item: item, listItemContainerStyle: listItemContainerStyle }));
    return React.createElement(React.Fragment, null,
        React.createElement(FlatList, { contentContainerStyle: styles.container, stickyHeaderHiddenOnScroll: true, stickyHeaderIndices: [0], ListHeaderComponent: (React.createElement(React.Fragment, null,
                React.createElement(SearchBar, { containerStyle: {
                        paddingHorizontal: horizontalGutter,
                        backgroundColor: backgroundPrimary,
                        borderBottomColor: borderSecondary,
                        borderTopWidth: 0,
                    }, inputContainerStyle: {
                        backgroundColor: borderSecondary,
                    }, inputStyle: {
                        color: textPrimary,
                    }, searchIcon: {
                        color: textPrimary,
                    }, clearIcon: {
                        color: textPrimary,
                    }, placeholderTextColor: textPrimary, platform: 'default', placeholder: "Search", onChangeText: (text) => { setDisplay(text || ''); }, value: display }),
                React.createElement(SearchRecommendations, { onSelected: setDisplay }),
                data?.count !== undefined && (React.createElement(BaseListItem, { containerStyle: [
                        { paddingHorizontal: horizontalGutter },
                        listItemContainerStyle,
                    ] },
                    React.createElement(BaseListItem.Content, null,
                        React.createElement(Text, null,
                            "Results: ",
                            data.count)))))), ListEmptyComponent: (React.createElement(SearchListEmptyComponent, { isLoading: !!(isPending && query), EmptySearchComponent: EmptySearchComponent, listItemContainerStyle: listItemContainerStyle })), keyExtractor: ({ item }) => `${item?.__typename}-${item?.id}`, data: data?.results || [], renderItem: renderItem, onEndReached: () => {
                if (hasNextPage)
                    fetchNextPage();
            }, onEndReachedThreshold: 0.5, onScrollToIndexFailed: () => { }, style: styles.flatlist }));
};
const styles = StyleSheet.create({
    container: { flexGrow: 1 },
    flatlist: Platform.select({
        web: {
            height: 'calc(100vh - var(--nav-bar-height) - var(--mini-player-height))',
            maxHeight: '100vh',
        },
        default: {},
    })
});
export const Search = withTheme(UnthemedSearch, 'Search');
//# sourceMappingURL=Search.js.map